/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Components
import Button from '../buttons/secondary';

function Plan(props) {
        if(props.active == true) {
            return (
                <div className='game-item'>
                    <div className={props.className + ' bg-minecraft bg-cover bg-no-repeat bg-center h-100 pt-86 rounded-lg'}>
                        <h1 className='text-gray-100 text-xl text-center font-semibold'>Starts at ${props.price}</h1>
                    </div>
                    <div className='flex justify-center'>
                        <Button link={props.link} type={props.linkType} title="Order Now" Style="margin-top: -25px;" />
                    </div>
                </div>
            )
        } else {
            return (
                <div className='game-item'>
                    <div className={props.className + ' bg-minecraft bg-cover bg-no-repeat bg-center h-100 pt-86 rounded-lg'}>
                        <h1 className='text-gray-100 text-xl text-center font-semibold'>Starts at ${props.price}</h1>
                    </div>
                    <div className='flex justify-center'>
                        <Button title="Coming Soon" active={false} Style="margin-top: -25px;" />
                    </div>
                </div>
            )
        }
}

export default Plan